module.exports = "<div class=\"media\">\n  <img class=\"mr-3 rounded align-self-center img-fluid\" style=\"width: 70px;\" [src]=\"'./assets/images/' + artist.shortname + '_tn.jpg'\" alt=\"'Photo of ' + artist.name \">\n  <div class=\"media-body align-self-center\">\n    <h5 class=\"m-0\">{{ artist.name }}</h5>\n    {{ artist.reknown }}\n  </div><!-- media body -->\n</div><!-- media -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/artist-items/artist-items.component.html
// module id = ./src/app/artist-items/artist-items.component.html
// module chunks = main